import React, { useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../form-components/input/Input";
import Button from "../form-components/input/Button";
import { toast } from "react-toastify";

const ChangePassword: React.FC = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [status, setStatus] = useState('idle');
    const [error, setError] = useState<string | null>(null);
    const authToken = sessionStorage.getItem('token');
    const navigate = useNavigate();
    
    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        setError(null);
        setStatus('loading');

        if (confirmPassword !== newPassword) {
            setError('Passwords do not match');
            setStatus('idle');
            return;
        }

        try {
            const response = await fetch('https://backend-kyw8.onrender.com/change-password', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify({ oldPassword, newPassword })
            });

            const data = await response.json();

            if (response.status === 400) {
                setError(data.message)
                console.log(data)
            } else if (response.status === 200) {
                toast.success(data.message, {
                    position: 'top-center'
                });
                navigate('/');
            } else {
                toast.error('An unexpected error occurred. Please try again later.', {
                    position: 'bottom-right',
                });
            }

        } catch (error) {
            console.error('Error:', error);
            toast.error('An unexpected error occurred. Please try again later.', {
                position: 'bottom-right',
            });
        } finally {
            setStatus('idle');
        }
    };

    return (
        <div className="mt-20 flex justify-center items-center">
            <div className="lg:border w-2/4 rounded-lg mt-20 lg:shadow-lg lg:bg-gray-100 lg:bg-opacity-80 p-8">
                <p className="text-xl font-semibold text-center mb-4">Change Password</p>
                <form onSubmit={handleSubmit}>
                    <Input
                        type="password"
                        label="Enter Current Password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        required
                    />
                    <Input
                        type="password"
                        label="Enter New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    <Input
                        type="password"
                        label="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    {error && <p className="text-red-500">{error}</p>}
                    <Button
                        type="submit"
                        isLoading={status === 'loading'}
                        buttonText="Change Password"
                    />
                </form>
            </div>
        </div>
    );
};

export default ChangePassword;
